export default __webpack_public_path__ + "static/media/SmallCTAcceptableMovementEdited.62484bbb.mp4";